/**
 * @summary - Component that Provides User Registration Form
 * @author Purushothaman T
 * @since 19-06-2024
 */
import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { DefaultCard } from "../../assets/styled-components/card";
import {
    validations,
} from "../../utility/constants/errors/messages";
import { ifacSecurityURL } from "../../utility/apiURLS";
import {
    getAuthToken,
    getuserId,
} from "../../utility/tokenUtility";
import utils from "../../utility/utilities";
import ActionButtons from "../commoncomponents/ActionButtons";
import CustomDialog from "../commoncomponents/CustomDialog";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import CustomTextField from "../commoncomponents/CustomTextField";
import PageTitle from "../commoncomponents/PageTitle";
import { dialogContent } from "../../utility/message";
import CustomTextFieldWithSearch from "../commoncomponents/CustomTextFieldWithSearch";
import utilities from "../../utility/utilities";
import RegionFacility from "./RegionFacility";
import { encryptionKey } from "../../utility/secretKeys";
import PageLoader from "../commoncomponents/PageLoader"

const Form = () => {
    const active = {
        label: "Active",
        value: "Active",
        id: true,
    };
    const inActive = {
        label: "Inactive",
        value: "Inactive",
        id: false,
    }

    const token = getAuthToken("id_token");
    const config = {
        headers: {
            // Attach bearer token to request header
            Authorization: `Bearer ${token}`,
        },
    };

    const vendorTypeId = 4

    const statusOptions = [active, inActive];
    const [formUserId, setFormUserId] = useState("")
    const [firstName, setFirstName] = useState("")
    const [lastName, setLastName] = useState("")
    const [employeeNo, setEmployeeNo] = useState("")
    const [companyCode, setCompanyCode] = useState("")
    const [roleName, setRoleName] = useState("")
    const [email, setEmail] = useState("")
    const [status, setStatus] = useState(statusOptions[0]);
    const [userType, setUserType] = useState("");
    const [companyName, setCompanyName] = useState("")
    const [roleDesc, setRoleDesc] = useState("")
    const [staffStatus, setStaffStatus] = useState("")
    const [companyCodeOptions, setCompanyCodeOtions] = useState([])
    const [staffStatusOptions, setStaffStatusOptions] = useState([])
    const [companyId, setCompanyId] = useState("")
    const [roleNameOptions, setRoleNameOptions] = useState([])
    const [userTypeOptions, setUserTypeOptions] = useState([])
    const [departmentName, setDepartmentName] = useState("")
    const [facilities, setFacilities] = useState([])
    const [id, setId] = useState("");
    const [userData, setUserData] = useState([]);
    const [reset, setReset] = useState(false)
    const [userTypeId, setUserTypeId] = useState("")
    const [isLoading, setIsLoading] = useState(false)
    const [isTypeChanged, setIsTypeChanged] = useState(false)

    const handleUserIdChange = (newValue) => {
        setIsChanged(true);
        setFormUserId(newValue);
        if (newValue) {
            setErrors((prev) => ({ ...prev, userId: false }));
            setErrorMessages((prev) => ({ ...prev, userId: "" }));
        }
        if (utils.validateUserId(newValue) || !newValue) {
            setErrors((prev) => ({ ...prev, userId: false }));
            setErrorMessages((prev) => ({ ...prev, userId: "" }));
        } else if (!utils.validateUserId(newValue)) {
            setErrors((prev) => ({ ...prev, userId: true }));
            setErrorMessages((prev) => ({
                ...prev,
                userId: validations.userId,
            }));
        }
    };


    const handleFirstNameChange = (newValue) => {
        setIsChanged(true);
        setFirstName(newValue);
        if (newValue) {
            setErrors((prev) => ({ ...prev, firstName: false }));
            setErrorMessages((prev) => ({ ...prev, firstName: "" }));
        }
        if (utils.validateTextField(newValue) || !newValue) {
            setErrors((prev) => ({ ...prev, firstName: false }));
            setErrorMessages((prev) => ({ ...prev, firstName: "" }));
        } else if (!utils.validateTextField(newValue)) {
            setErrors((prev) => ({ ...prev, firstName: true }));
            setErrorMessages((prev) => ({
                ...prev,
                firstName: validations.textfield,
            }));
        }
    };

    const handleLastNameChange = (newValue) => {
        setIsChanged(true);
        setLastName(newValue);
        if (newValue) {
            setErrors((prev) => ({ ...prev, lastName: false }));
            setErrorMessages((prev) => ({ ...prev, lastName: "" }));
        }
        if (utils.validateTextField(newValue) || !newValue) {
            setErrors((prev) => ({ ...prev, lastName: false }));
            setErrorMessages((prev) => ({ ...prev, lastName: "" }));
        } else if (!utils.validateTextField(newValue)) {
            setErrors((prev) => ({ ...prev, lastName: true }));
            setErrorMessages((prev) => ({
                ...prev,
                lastName: validations.textfield,
            }));
        }
    };

    const handleEmployeeNoChange = (newValue) => {
        setIsChanged(true);
        setEmployeeNo(newValue);
        if (newValue) {
            setErrors((prev) => ({ ...prev, employeeNo: false }));
            setErrorMessages((prev) => ({ ...prev, employeeNo: "" }));
        }
        if (utils.validateUserId(newValue) || !newValue) {
            setErrors((prev) => ({ ...prev, employeeNo: false }));
            setErrorMessages((prev) => ({ ...prev, employeeNo: "" }));
        } else if (!utils.validateUserId(newValue)) {
            setErrors((prev) => ({ ...prev, employeeNo: true }));
            setErrorMessages((prev) => ({
                ...prev,
                employeeNo: validations.userId,
            }));
        }
    };

    const handleCompanyCodeChange = (newvalue) => {
        if (newvalue.label === "") {
            setCompanyCode({ label: "", value: "" });
            setCompanyName("");
            setRoleName({ label: "", value: "" });
            setRoleDesc("");
            setUserType("")
            setErrors((prev) => ({ ...prev, userType: false, roleName: false }));
        } else {
            setUserType("")
            setRoleName({ label: "", value: "" });
            setRoleDesc("");
            setIsChanged(true);
            setCompanyId(newvalue?.id)
            setCompanyCode({ ...newvalue, label: newvalue.value });
            setCompanyName(newvalue?.companyname);
            setErrors((prev) => ({ ...prev, companyCode: false }));
            setErrorMessages((prev) => ({
                ...prev,
                companyCode: "",
            }));
        }
    };

    const handleRoleNameChange = (newvalue) => {
        if (newvalue.label === "") {
            setRoleName("");
            setRoleDesc("");
        } else {
            setIsChanged(true);
            setRoleName({ ...newvalue, label: newvalue.value });
            setRoleDesc(newvalue?.roleDesc);
            setErrors((prev) => ({ ...prev, roleName: false }));
            setErrorMessages((prev) => ({
                ...prev,
                roleName: "",
            }));
        }
    };
    const handleStatusChange = (newValue) => {
        setIsChanged(true);
        setStatus(newValue);
    };

    const handleStaffStatusChange = (newValue) => {
        setIsChanged(true);
        setStaffStatus(newValue);
        if (newValue.label !== "") {
            setErrors((prev) => ({ ...prev, staffStatus: false }));
            setErrorMessages((prev) => ({
                ...prev,
                staffStatus: "",
            }));

        }
    };

    const handleUserTypeChange = (newValue) => {
        if (userType?.id !== newValue?.id) {
            setIsTypeChanged(true)
        }
        setIsChanged(true);
        setUserType(newValue);
        setRoleName({ label: "", value: "" });
        setRoleDesc("");
        if(newValue?.id === vendorTypeId){
            setFormUserId("")
            setEmployeeNo("")
        }
        fetchRoleOptions(companyId, newValue?.id)
        if (newValue.label !== "") {
            setErrors((prev) => ({ ...prev, userType: false }));
            setErrorMessages((prev) => ({
                ...prev,
                userType: "",
            }));

        }
    };

    const handleEmailChange = (value) => {
        setIsChanged(true);
        setEmail(value);
        if (value) {
            if (!utilities.validateEmail(value)) {
                setErrors((prev) => ({ ...prev, email: true }));
                setErrorMessages((prev) => ({
                    ...prev,
                    email: validations.email,
                }));
            } else {
                setErrors((prev) => ({ ...prev, email: false }));
                setErrorMessages((prev) => ({ ...prev, email: "" }));
            }
        } else {
            setErrors((prev) => ({ ...prev, email: false }));
            setErrorMessages((prev) => ({ ...prev, email: "" }));
        }
    };

    const navigate = useNavigate();
    const location = useLocation();
    const userId = getuserId();
    const [isChanged, setIsChanged] = useState(false);

    useEffect(() => {
        if (location.state) {
            const { isEditMode, isViewMode, id, companyId } = location.state;
            setIsEdit(isEditMode);
            setIsView(isViewMode);
            setId(id);
            setCompanyId(companyId)
        }
    }, [location.state]);
    const [isEdit, setIsEdit] = useState(false);
    const [isView, setIsView] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [openValidationDialog, setOpenValidationDialog] = useState(false);
    const [contentDialog, setContentDialog] = useState("");
    const [enableSubmit, setEnableSubmit] = useState(true);
    const [isAddNew, setIsAddNew] = useState(false);
    const [errors, setErrors] = useState({});
    const [errorMessages, setErrorMessages] = useState({});

    useEffect(() => {
        if (id && (isEdit || isView)) {
            fetchEditData(id);
        }
    }, [id, isEdit, isView]);

    useEffect(() => {
        if (userData.length > 0) {
            const selectedDefaultRole = roleNameOptions.find((option) => option?.roleId === userData[0]?.defaultRoleId)
            setFormUserId(userData[0]?.userName);
            setFirstName(userData[0]?.firstName);
            setLastName(userData[0]?.lastName);
            setEmployeeNo(userData[0]?.userEmpNo);
            setCompanyCode({ label: userData[0]?.companyCode, id: userData[0]?.companyId });
            setCompanyName(userData[0]?.companyName);
            setStaffStatus(staffStatusOptions.find((option) => option?.id === userData[0]?.staffStatusId));
            setRoleName({ ...selectedDefaultRole, label: selectedDefaultRole?.value });
            setRoleDesc(userData[0]?.defaultRoleDesc);
            setEmail(userData[0]?.emailId);
            setUserType(userTypeOptions.find((option) => option?.id === userData[0]?.userTypeId));
            setStatus(statusOptions.find((option) => option?.id === userData[0]?.isactive));
        }
    }, [userData]);

    useEffect(() => {
        fetchOptions();
    }, []);

    const fetchOptions = async () => {
        try {
            const config = {
                headers: {
                    // Attach bearer token to request header
                    Authorization: `Bearer ${token}`,
                },
            };
            const [companyResponse, userTypeResponse, staffStatusResponse] = await Promise.all([
                axios.get(`${ifacSecurityURL}/api/GraphSecCompanyRegister/GetSeccompanyregisterList?size=1000`, config),
                axios.get(`${ifacSecurityURL}/api/secusertypes`, config),
                axios.get(`${ifacSecurityURL}/api/secstaffstatuses?size=1000`, config),
            ])

            setCompanyCodeOtions(companyResponse.data.map((company) => {
                return {
                    ...company,
                    label: `${company?.companycode} - ${company?.companyname}`,
                    value: company?.companycode,
                }
            }))
            setUserTypeOptions(userTypeResponse.data.map((userType) => {
                return {
                    ...userType,
                    label: userType?.usertype,
                    value: userType?.usertype,
                }
            }))
            setStaffStatusOptions(staffStatusResponse.data.map((userType) => {
                return {
                    ...userType,
                    label: userType?.staffstatus,
                    value: userType?.staffstatus,
                }
            }))
        }
        catch (error) {
            console.error("Error fetching service options:", error);
        }
    };

    const fetchRoleOptions = async (companyId, userTypeId) => {
        try {
            const config = {
                headers: {
                    // Attach bearer token to request header
                    Authorization: `Bearer ${token}`,
                },
            };
            const roleResponse = await axios.get(`${ifacSecurityURL}/api/GraphUserRegistration/GetSecUserTypeList/${companyId}/${userTypeId}?size=1000`, config);
            setRoleNameOptions(roleResponse.data.map((role) => {
                return {
                    ...role,
                    label: `${role?.roleCode} - ${role?.roleDesc}`,
                    value: role?.roleCode,
                }
            }))
        }
        catch (error) {
            console.error("Error fetching service options:", error);
        }
    };



    const fetchEditData = async (id) => {
        setIsLoading(true)
        try {
            const config = {
                headers: {
                    // Attach bearer token to request header
                    Authorization: `Bearer ${token}`,
                },
            };
            await fetchOptions();
            const userResponse = await axios.get(`${ifacSecurityURL}/api/GraphUserRegistration/GetSecuserregisterListById/${id}?size=1000`, config)
            setUserTypeId(userResponse?.data[0].userTypeId)
            await fetchRoleOptions(companyId, userResponse?.data[0].userTypeId);
            setUserData(userResponse.data);
        }

        catch (error) {
            console.error("Error fetching service options:", error);
        }
        finally {
            setIsLoading(false)
        }
    };

    const handleCancel = () => {
        if (!isChanged) {
            navigate("/user");
        }
        setOpenDialog(true);
        setContentDialog(dialogContent.modified);
    };

    const handleAddNew = () => {
        if (isChanged) {
            setIsAddNew(true);
            setOpenDialog(true);
            setContentDialog(dialogContent.modified);
        } else {
            setDeafault();
        }
    };

    const handleDialogClose = () => {
        setOpenDialog(false);
        if (isAddNew) {
            setIsAddNew(false);
        }
    };

    const handleDialogConfirm = () => {
        setOpenValidationDialog(false);
        setOpenDialog(false);
        if (isChanged && !openValidationDialog && !isAddNew) {
            navigate("/user");
        }
        if (isAddNew) {
            setDeafault();
        }
    };

    const confirmReset = async () => {
        setOpenDialog(false);
        try {
            const hostnameAndPort = `${window.location.hostname}:${window.location.port}`;
            // const response = await axios.post(`${ifacSecurityURL}/api/account/forgot-password`, { email: userData[0]?.emailId, applicationSecurityKey: encryptionKey, url: hostnameAndPort });
            const response = await axios.post(`${ifacSecurityURL}/api/account/forgot-password`, { login: userData[0]?.userName, email: userData[0]?.emailId, applicationSecurityKey: encryptionKey, url: hostnameAndPort });
            if (response.status === 200) {
                setOpenValidationDialog(true);
                setContentDialog(dialogContent.reset);
                setReset(false)
            }

        }
        catch (error) {
            console.error("Error fetching service options:", error);
        }
    };

    const setDeafault = () => {
        setFormUserId("");
        setFirstName("");
        setLastName("");
        setEmployeeNo("");
        setCompanyCode({ label: "", value: "" });
        setCompanyName("");
        setStaffStatus("");
        setRoleName({ label: "", value: "" });
        setEmail("");
        setStatus(statusOptions[0]);
        setRoleDesc("");
        setUserType("");
        setDepartmentName({ label: "", value: "" });
        setEnableSubmit(true);
        setErrors({});
        setErrorMessages({});
        setIsAddNew(false);
        setIsChanged(false);
    };

    const handleSubmit = (e) => {
        let isFormValid = true;
        if (!formUserId && userType?.id !== vendorTypeId) {
            isFormValid = false;
            setErrors((prev) => ({ ...prev, userId: true }));
            setErrorMessages((prev) => ({
                ...prev,
                userId: "User Name is required",
            }));
        }
        if (!firstName) {
            isFormValid = false;
            setErrors((prev) => ({ ...prev, firstName: true }));
            setErrorMessages((prev) => ({
                ...prev,
                firstName: "First Name is required",
            }));
        }
        if (!lastName) {
            isFormValid = false;
            setErrors((prev) => ({ ...prev, lastName: true }));
            setErrorMessages((prev) => ({
                ...prev,
                lastName: "Last Name is required",
            }));
        }
        if (!companyCode?.label) {
            isFormValid = false;
            setErrors((prev) => ({ ...prev, companyCode: true }));
            setErrorMessages((prev) => ({
                ...prev,
                companyCode: "Company Code is required",
            }));
        }
        if (!staffStatus?.label) {
            isFormValid = false;
            setErrors((prev) => ({ ...prev, staffStatus: true }));
            setErrorMessages((prev) => ({
                ...prev,
                staffStatus: "Staff Status is required",
            }));
        }
        if (!userType?.label && companyCode?.label) {
            isFormValid = false;
            setErrors((prev) => ({ ...prev, userType: true }));
            setErrorMessages((prev) => ({
                ...prev,
                userType: "User Type is required",
            }));
        }
        if (!roleName?.label && userType?.label) {
            isFormValid = false;
            setErrors((prev) => ({ ...prev, roleName: true }));
            setErrorMessages((prev) => ({
                ...prev,
                roleName: "Role Name is required",
            }));
        }
        if (!employeeNo && userType?.id !== vendorTypeId) {
            isFormValid = false;
            setErrors((prev) => ({ ...prev, employeeNo: true }));
            setErrorMessages((prev) => ({
                ...prev,
                employeeNo: "User Employee No is required",
            }));
        }
        if (userType?.id === 3 && facilities.filter((f) => f.checked).some((dept) => dept?.department?.length === 0 || !dept?.hasOwnProperty('department'))) {
            isFormValid = false;
            setOpenValidationDialog(true)
            setContentDialog("Please select at least one department for each of the selected locations.")
        }
        if (
            errors.userId ||
            errors.firstName ||
            errors.lastName ||
            errors.employeeNo ||
            errors.companyCode ||
            errors.staffStatus ||
            errors.roleName ||
            errors.email ||
            errors.status ||
            errors.userType
        ) {
            isFormValid = false;
        }

        if (isFormValid) {
            const isFacilitySelected = facilities.filter((f) => f.checked).length > 0;
            if (isFacilitySelected) {
                handlesave();
            } else {
                setOpenValidationDialog(true);
                setContentDialog("Please select at least one location.");
            }
        }
    };

    const handlesave = async () => {
        const postDataUser = {
            id: "",
            login: formUserId || null,
            username: formUserId || null,
            firstname: firstName || null,
            lastname: lastName || null,
            isDeleted: false,
            password: "Welcome@123",
            roleId: roleName?.roleId || null,
            theme: "default",
            widgets: "1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20|5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20",
            isActive: status?.id || null,
            createdBy: userId || null,
            lastModifiedBy: userId || null,
            token: token,
            userTypeId: userType?.id,
            activated: status?.id || null,
            ...(email ? { email } : {}) // Dynamically add 'email' if not empty
        };

        const userDetails = {
            id: "",
            createdBy: userId,
            modifiedBy: userId,
            userempno: employeeNo ?? "",
            departmentId: userType?.id === 3 ? departmentName?.id : null,
            staffStatusId: staffStatus?.id,
            userTypeId: userType?.id,
            ...(userType?.id === 3 && { departmentId: departmentName?.id }),
            userId: formUserId ?? "",
            isDeleted: false
        }
        const postUserDetails = facilities.filter((f) => !f.id).map((facility) => {

            facility.roleId = !facility.roleId ? roleName?.roleId : facility.roleId;


            return {
                ...userDetails,
                ...facility,
                departmentId: userType?.id === 3 ? facility.department.map((dept) => dept?.id).join(",") : "",
            }
        })

        const putDataUser = {
            id: id,
            login: userData?.[0]?.login || null,
            username: userData?.[0]?.userName || null,
            firstname: firstName || null,
            lastname: lastName || null,
            isDeleted: false,
            roleId: roleName?.roleId || null,
            theme: userData?.[0]?.theme || null,
            widgets: userData?.[0]?.widgets || null,
            isActive: status?.id,
            activated: status?.id,
            createdBy: userData?.[0]?.createdBy || null,
            lastModifiedBy: userId || null,
            token: token,
            ...(email ? { email } : {}) // Dynamically add 'email' if not empty
        };

        const putUserDetails = facilities.filter((f) => f.id).map((facility) => {
            return {
                id: facility?.id,
                facilityId: facility?.facilityId,
                createdBy: userId,
                modifiedBy: userId,
                isdeleted: facility?.isdeleted,
                userempno: facility?.userEmpNo,
                staffStatusId: staffStatus?.id,
                userTypeId: userType?.id,
                departmentId: userType?.id === 3 ? facility.department.map((dept) => dept?.id).join(",") : "",
                userId: facility?.userId,
                roleId: userTypeId === userType?.id ? (facility?.roleId) : (facility?.roleId ? facility?.roleId : roleName?.roleId)
            }
        })

        const endpointusers = isEdit ? `${ifacSecurityURL}/api/admin/Users` : `${ifacSecurityURL}/api/register`;
        const endpointuserdetailsput = `${ifacSecurityURL}/api/secuserdetails/${id}`;
        const endpointuserdetailspost = `${ifacSecurityURL}/api/secuserdetails/`;

        if (isEdit) {

            const res = await putMethod(endpointusers, putDataUser, config)
            const res1 = await putMethod(endpointuserdetailsput, putUserDetails, config)
            const data = postUserDetails.map((user) => ({
                ...user,
                userId: id
            }));
            let res2
            if (data.length > 0) {
                res2 = await postMethod(endpointuserdetailspost, data, config);
            }
            if (res?.status === 200 && res1?.status === 200 && (isEdit || res2?.status === 200)) {
                setContentDialog(dialogContent.updated);
                setIsChanged(false);
                setOpenValidationDialog(true);
                fetchEditData(id);
            }


        } else {
            try {
                let empRes

                if (userType?.id !== vendorTypeId) {
                    empRes = await axios.get(`${ifacSecurityURL}/api/GraphUserRegistration/GetSecuserregisterEmpCheck/${employeeNo}`, config)
                }

                if (empRes?.status === 200 || userType?.id === vendorTypeId) {
                    const res = await postMethod(endpointusers, postDataUser, config).then(
                        (response) => {
                            if (response?.status === 201) {
                                if (userType?.id === vendorTypeId){
                                    setFormUserId(response.data.login)
                                    setEmployeeNo(response.data.userName)
                                }
                                const data = postUserDetails.map((user) => ({
                                    ...user,
                                    userId: response?.data?.id,
                                    userempno:response.data.userName
                                }));
                                const res = postMethod(endpointuserdetailspost, data, config);
                               
                                return res;
                            }
                        }
                    )
                    if (res?.status === 200) {
                        setContentDialog(dialogContent.saved);
                        setIsChanged(false);
                        setOpenValidationDialog(true);
                        setEnableSubmit(false);
                    }
                }
            }
            catch (error) {
                if (error.response.status === 400) {
                    setOpenValidationDialog(true);
                    setContentDialog(error.response.data.detail || validations.default);
                }
                console.log(error);
            }
        }
    };

    const postMethod = async (endpoint, postData, config) => {
        try {
            const result = await axios({
                method: "post",
                url: endpoint,
                data: postData,
                headers: config.headers,
            });
            return result;
        } catch (error) {
            if (error.response.status === 400) {
                setOpenValidationDialog(true);
                setContentDialog(error.response.data.detail || validations.default);
            }
            console.log(error);
        }
    };

    const putMethod = async (endpoint, postData, config) => {
        try {
            const res = await axios({
                method: "put",
                url: endpoint,
                data: postData,
                headers: config.headers,
            })
            return res
        } catch (error) {
            if (error.response.status === 400) {
                setContentDialog(error ? error.response.data.detail : "Error Occured!");
                setOpenValidationDialog(true);
            }
        }
    };

    const handleResetClick = () => {
        setContentDialog(dialogContent.confirmReset);
        setOpenDialog(true);
        setReset(true);
    };

    return (
        <>
            <PageTitle
                isEdit={isEdit}
                isView={isView}
                editTitle={"Edit User Registration"}
                viewTitle={"View User Registration"}
                title={"Create User Registration"}
            />
            <DefaultCard>
                <Grid container spacing={4}>

                    <Grid item xs={6} md={4}>
                        <CustomTextFieldWithSearch
                            label={"Company Code"}
                            isMandatoryField={true}
                            value={companyCode}
                            onChange={handleCompanyCodeChange}
                            options={companyCodeOptions}
                            disabled={isView || isEdit}
                            error={errors.companyCode}
                            helperText={errorMessages.companyCode}
                        />
                    </Grid>

                    <Grid item xs={6} md={4}>
                        <CustomTextField
                            label="Company Name"
                            value={companyName}
                            disabled={true}
                        />
                    </Grid>


                    <Grid item xs={6} md={4}>
                        <CustomSelectInput
                            error={errors.userType}
                            disableClearable={true}
                            label="User Type"
                            isMandatoryField={true}
                            value={userType}
                            onChange={handleUserTypeChange}
                            options={isEdit ? userTypeOptions.filter((f) => f.id !== vendorTypeId) : userTypeOptions}
                            helperText={errorMessages.userType}
                            disabled={!companyCode.label || isView || (isEdit && userType.id === vendorTypeId)}
                        />
                    </Grid>

                    <Grid item xs={6} md={4}>
                        <CustomTextFieldWithSearch
                            label={"Default Role Name"}
                            isMandatoryField={true}
                            value={roleName}
                            onChange={handleRoleNameChange}
                            disabled={(!companyCode.label || !userType.label) || isView}
                            options={roleNameOptions}
                            error={errors.roleName}
                            helperText={errorMessages.roleName}
                            clear={() => setIsChanged(true)}
                        />
                    </Grid>

                    <Grid item xs={6} md={4}>
                        <CustomTextField
                            label="Role Description"
                            value={roleDesc}
                            disabled={true}
                        />
                    </Grid>

                    <Grid item xs={6} md={4}>
                        <CustomTextField
                            label="User Name"
                            isMandatoryField={userType?.id !== vendorTypeId}
                            id="userId"
                            value={formUserId}
                            maxlength={15}
                            onChange={handleUserIdChange}
                            disabled={isView || isEdit || userType?.id === vendorTypeId}
                            error={errors.userId}
                            helperText={errorMessages.userId}
                        />
                    </Grid>

                    <Grid item xs={6} md={4}>
                        <CustomTextField
                            label="First Name"
                            isMandatoryField={true}
                            value={firstName}
                            maxlength={60}
                            onChange={handleFirstNameChange}
                            error={errors.firstName}
                            helperText={errorMessages.firstName}
                            disabled={isView}
                        />
                    </Grid>

                    <Grid item xs={6} md={4}>
                        <CustomTextField
                            label="Last Name"
                            isMandatoryField={true}
                            value={lastName}
                            maxlength={60}
                            onChange={handleLastNameChange}
                            error={errors.lastName}
                            helperText={errorMessages.lastName}
                            disabled={isView}
                        />
                    </Grid>
                    <Grid item xs={6} md={4}>
                        <CustomTextField
                            label="User Employee No"
                            isMandatoryField={userType?.id !== vendorTypeId}
                            value={employeeNo}
                            maxlength={10}
                            onChange={handleEmployeeNoChange}
                            disabled={isView || isEdit || userType?.id === vendorTypeId}
                            error={errors.employeeNo}
                            helperText={errorMessages.employeeNo}
                        />
                    </Grid>



                    <Grid item xs={6} md={4}>
                        <CustomTextField
                            maxlength={100}
                            label="Email"
                            value={email}
                            onChange={handleEmailChange}
                            error={errors.email}
                            helperText={errorMessages.email}
                            disabled={isView}
                        />
                    </Grid>

                    <Grid item xs={6} md={4}>
                        <CustomSelectInput
                            disableClearable={true}
                            label="Status"
                            value={status}
                            onChange={handleStatusChange}
                            options={statusOptions}
                            disabled={isView}
                        />
                    </Grid>

                    <Grid item xs={6} md={4}>
                        <CustomSelectInput
                            error={errors.staffStatus}
                            disableClearable={true}
                            label="Staff Status"
                            isMandatoryField={true}
                            value={staffStatus}
                            onChange={handleStaffStatusChange}
                            options={staffStatusOptions}
                            helperText={errorMessages.staffStatus}
                            disabled={isView}
                        />
                    </Grid>


                </Grid>

                {isEdit && userData[0]?.emailId && (
                    <Box mt={5}>
                        <Stack
                            direction="row"
                            gap={1.5}
                            mt={3}
                            justifyContent="end"
                            alignItems="center"
                        >
                            <Typography>
                                <b>Note <span style={{ color: "red" }}>*</span>:</b> Default password is <b>Welcome@123</b>
                            </Typography>
                            <Button
                                variant="contained"
                                sx={{ backgroundColor: "#B388EB", fontWeight: "bold" }}
                                onClick={handleResetClick}
                            >
                                RESET PASSWORD
                            </Button>
                        </Stack>
                    </Box>
                )}

                <Box mt={5}>
                    <RegionFacility
                        userData={userData}
                        roleNameOptions={roleNameOptions}
                        companyCode={companyCode}
                        isTypeChanged={isTypeChanged}
                        setIsTypeChanged={setIsTypeChanged}
                        setFacilities={setFacilities}
                        isEdit={isEdit}
                        isView={isView}
                        isChanged={() => setIsChanged(true)}
                        userType={userType}
                    />
                </Box>

                <ActionButtons
                    handleCancel={handleCancel}
                    handleSubmit={(e) => handleSubmit(e)}
                    handleAddNew={handleAddNew}
                    enableSubmit={enableSubmit}
                    isEdit={isEdit}
                    isView={isView}
                />
            </DefaultCard>

            <CustomDialog
                cancelBtn={"No"}
                open={openDialog}
                onConfirm={reset ? confirmReset : handleDialogConfirm}
                content={contentDialog}
                onClose={handleDialogClose}
                confirmBtn={"Yes"}
            />
            <CustomDialog
                open={openValidationDialog}
                onConfirm={handleDialogConfirm}
                content={contentDialog}
                onClose={handleDialogClose}
                confirmBtn={"Ok"}
            />
            <PageLoader open={isLoading} />
        </>
    );
};

export default Form;
